import {
  DELETING_ACCOUNT,
  DELETE_ACCOUNT_FAILURE,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_CLEAR_FAILURE_ERROR,
} from 'constants/ActionTypes';

const initState = {
  accountDeletionSuccess: false,
  accountDeletionError: false,
  deletingAccount: false,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case DELETING_ACCOUNT: return { ...state, deletingAccount: true };
    case DELETE_ACCOUNT_SUCCESS: return {
      ...state, accountDeletionSuccess: true, accountDeletionError: false, deletingAccount: false,
    };
    case DELETE_ACCOUNT_FAILURE: return { ...state, accountDeletionError: true, deletingAccount: false };
    case DELETE_ACCOUNT_CLEAR_FAILURE_ERROR: return { ...state, accountDeletionError: false };
    default: return state;
  }
};
